/* eslint-disable no-console */
export function fallbackCopyTextToClipboard() {
    try {
        return document.execCommand('copy');
    } catch (error) {
        console.error(error);
        return false;
    }
}

export function copyTextToClipboard(text) {
    return navigator.clipboard.writeText(text).then(
        () => true,
        error => {
            console.error('Async: Could not copy text: ', error);
            return false;
        }
    );
}
/* eslint-enable no-console */
